import { AnimatePresence } from 'framer-motion';
import { lazy, Suspense } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import ScrollToTop from './components/ScrollToTop';
import AppFooter from './components/shared/AppFooter';
import AppHeader from './components/shared/AppHeader';
import './css/App.css';
import UseScrollToTop from './hooks/useScrollToTop';
// import '@mantine/core/styles.css';


const About = lazy(() => import('./pages/AboutMe'));
const Contact = lazy(() => import('./pages/Contact.jsx'));
const Home = lazy(() => import('./pages/Home'));
const Projects = lazy(() => import('./pages/Projects'));
const ProjectSingle = lazy(() => import('./pages/ProjectSingle.jsx'));
const Blog = lazy(() => import('./pages/Blog.jsx'));
const BlogPost = lazy(() => import('./pages/BlogPost.jsx'));
const BlogPortal = lazy(() => import('./pages/BlogPortal.jsx'));


function App() {
	return (
		<AnimatePresence>
			<script src="../../script.js" defer></script>
			<div className="min-h-screen bg-[#F5F5F7] dark:bg-[#000000] text-slate-900 dark:text-[#F5F5F7] transition-colors duration-200">
				<Router>
					<ScrollToTop />
					<AppHeader />
					<Suspense fallback={""}>
						<Routes>
							<Route path="/" element={<Home />} />
							<Route path="projects" element={<Projects />} />
							<Route path="projects/single-project" element={<ProjectSingle />}/>
							<Route path="about" element={<About />} />
							<Route path="contact" element={<Contact />} />
							<Route path="blog" element={<Blog />} />
							<Route path="blog/portal" element={<BlogPortal />} />
							<Route path="blog/:slug" element={<BlogPost />} />
						</Routes>
					</Suspense>
					<AppFooter />
				</Router>
				<UseScrollToTop />
			</div>
		</AnimatePresence>
	);
}

export default App;
